module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-27.af1ccad3.png";